import PropTypes from 'prop-types';
import styled from 'foundations-theming/utils';
import { Button } from 'foundations-components/transitional/components/Button';
import { RemoveIcon } from 'foundations-assets';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
// @ts-expect-error not typed yet
import BeforeBeginPortal from 'ContentEditorUI/components/portals/BeforeBeginPortal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Container = styled.div.withConfig({
  displayName: "ExitLayoutModeButton__Container",
  componentId: "sc-1aj1pwt-0"
})(["z-index:3;position:absolute;top:20px;right:20px;"]);
const ExitLayoutModeButton = ({
  onClick
}) => {
  return /*#__PURE__*/_jsx(BeforeBeginPortal, {
    id: "exit-preview-and-layout-mode-button-container",
    targetElement: document.getElementsByClassName('contentEditor-exitButton')[0],
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Button, {
        use: "tertiary",
        paddingInlineStart: "300",
        paddingInlineEnd: "300",
        paddingBlockEnd: "200",
        "data-action": "exitLayoutMode",
        onClick: onClick,
        children: [/*#__PURE__*/_jsx(RemoveIcon, {}), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "layoutMode.exitLayoutMode"
        })]
      })
    })
  }, "exit-preview-and-layout-mode-button-container");
};
ExitLayoutModeButton.propTypes = {
  type: PropTypes.string.isRequired,
  onClick: PropTypes.func
};
export default ExitLayoutModeButton;